<template>
	<popup
			@updateClosePopup="onClose"
			@updateSave="onSave"
			height-head="40px"
			:is-btn-safe="!!getPermissionAction"
			title="Trailers"
			is-all-height
	>
		<div class="formDialog trailerForm" :class="{ 'onlyViewWrap': getPermissionAction }">
			<div class="formDialogHeader">
				<div class="formDialogHeader_card service" :class="{ 'onlyView': getPermissionAction }">
					<field
							margin="0"
							:class-error="$v.trailer_number && $v.trailer_number.$error"
							width="160px"
							label="Trailer #"
							placeholder="Enter trailer number"
							@updateInput="onInput($event, 'trailer_number')"
							:setInputValue="trailer_number"
							is-required
					></field>
					<field
							:class-error="$v.trailer_type_id && $v.trailer_type_id.$error"
							margin="0"
							width="170px"
							label="Trailer type"
							placeholder="Select trailer type"
							@updateAutocomplete="onAutocomplete($event, 'trailer_type_id')"
							:autocompleteValue="trailer_type_id"
							:items="trailerType"
							:isClearable="false"
							is-autocomplete
							is-required
					></field>
					<field
							:class-error="$v.size && $v.size.$error"
							margin="0"
							width="90px"
							label="size"
							@updateInput="onInput($event, 'size')"
							:setInputValue="size"
							icon="ft"
							is-required
					></field>
					<field
							:class-error="$v.customer_id && $v.customer_id.$error"
							margin="0"
							width="170px"
							label="Customer"
							placeholder="Select customer"
							@updateAutocomplete="onAutocomplete($event, 'customer_id')"
							:autocompleteValue="customer_id"
							:items="customers"
							:isClearable="false"
							is-autocomplete
							is-required
					></field>
					<field
							:class-error="$v.date_from && $v.date_from.$error"
							margin="0"
							width="134px"
							type="text"
							label="Date from"
							placeholder="Enter date from"
							displayFormat="YYYY-MM-DD"
							format="YYYY-MM-DD"
							:dateValue="date_from"
							@updateTime="onDate($event, 'date_from')"
							:pickTime="false"
							is-time
							is-required
					></field>
					<button @click="onChangeCompany(true)" type="button" :disabled="isChangeCompanyButton">
						<svg-sprite
								:style="`color: ${isChangeCompanyButton ? '#8F90A6' : '#19BC38'}`"
								icon-id="reset"
								height="20"
								width="20"
						></svg-sprite>
					</button>
					<div class="checkboxWrapper">
						<v-checkbox
								class="checkbox"
								:input-value="company_owner"
								label="Company owned"
								color="success"
								hide-details
								:disabled="getPermissionAction"
								@change="onCheckbox($event, 'company_owner')"
						></v-checkbox>
						<v-checkbox
								class="checkbox"
								:input-value="left_company"
								label="Left the company"
								color="success"
								hide-details
								:disabled="getPermissionAction"
								@change="onCheckbox($event, 'left_company')"
						></v-checkbox>
						<v-checkbox
								class="checkbox"
								:input-value="active"
								label="Active"
								color="success"
								hide-details
								:disabled="getPermissionAction"
								@change="onCheckbox($event, 'active')"
						></v-checkbox>
						<v-checkbox
								class="checkbox"
								:input-value="sold"
								label="Sold"
								color="success"
								hide-details
								:disabled="getPermissionAction"
								@change="onCheckbox($event, 'sold')"
						></v-checkbox>
					</div>
					<div class="groupField_wrap">
						<div :style="'background:' + getIndicatorColor" v-if="status_id" class="indicator"></div>
						<field
								margin="0 10px 0 auto"
								width="200px"
								label="Status"
								placeholder="Select status"
								@updateSelect="onAutocomplete($event, 'status_id')"
								:autocompleteValue="status_id"
								:items="statusList"
								:isClearable="false"
								is-select
						></field>
					</div>
				</div>
			</div>
			<div class="tabBlock">

				<tab-block
						:tab="tab"
						:tab-list="getTabList"
						@updateTab="onTab"
				></tab-block>

				<v-tabs-items v-model="tab" class="tabs-items">
					<v-tab-item>
						<first-tab
								:vin_code="vin_code"
								:plate="plate"
								:gps_name="gps_name"
								:gps="!!gps"
								:driver_id="driver_id"
								:team="!!team"
								:driver_second_id="driver_second_id"
								:model="model"
								:drivers="drivers"
								:customerId="!!customer_id"
								:isCreate="!this.trailerId"
								:valid="$v"
								:services="services"
								:trailerTypeId="trailer_type_id"
								:getPermissionAction="getPermissionAction"
								@updateFirstTab="onUpdateValueTab"
						></first-tab>
					</v-tab-item>
					<v-tab-item>
						<second-tab :permissions="permissions" :trailerId="trailerId"></second-tab>
					</v-tab-item>
					<v-tab-item>
						<thirdTab
								:trailerId="trailerId"
								:drivers="drivers"
								:equipments="equipments"
								:getPermissionAction="getPermissionAction"
								@updateEquipmentsSelectList="onEquipmentsSelectList"
						></thirdTab>
					</v-tab-item>
					<v-tab-item>
						<fifth-tab
								:trailerNumber="trailer_number"
								:trailerId="trailerId"
								:hours="hours"
								:originValue="originValue"
								:trailerTypeId="trailer_type_id"
								:getPermissionAction="getPermissionAction"
								@updateValueTab="onUpdateValueTab"
						></fifth-tab>
					</v-tab-item>
					<v-tab-item>
						<fourth-tab
								:getPermissionAction="getPermissionAction"
								:trailerId="trailerId"></fourth-tab>
					</v-tab-item>
				</v-tabs-items>

			</div>
			<change-company
					v-if="isChangeCompany"
					:items="change_company"
					:customers="customers"
					@updateSettingsClose="onChangeCompany(false)"
					@updateSettingsCancel="onChangeCompany(false)"
					@updateEditServices="onEditServices"
			></change-company>
		</div>
	</popup>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components
import FirstTab from "@/components/Maintenance/Trailers/TrailersForm/FirstTab/FirstTab";
import SecondTab from "@/components/Maintenance/Trailers/TrailersForm/SecondTab/SecondTab";
import ThirdTab from "@/components/Maintenance/Trailers/TrailersForm/ThirdTab/ThirdTab";
import FourthTab from "@/components/Maintenance/Trailers/TrailersForm/FourthTab/FourthTab";
import FifthTab from "@/components/Maintenance/Trailers/TrailersForm/FifthTab/FifthTab";
// shared
import Popup from "@/shared/Popup/Popup";
// constants
import { STATUS_TRUCK_COLOR } from "@/constants/constants";
// helper
import getDefaultDate from "@/helper/getDefaultDate";
import { required } from "vuelidate/lib/validators";
// validate
import { validationMixin } from "vuelidate";
import TabBlock from "@/shared/TabBlock/TabBlock.vue";
import ChangeCompany from "@/shared/ChangeCompany/ChangeCompany.vue";

export default {
	name: "TrailerForm",
	mixins: [ validationMixin ],
	components: {
		TabBlock,
		FirstTab,
		Popup,
		ChangeCompany,
		SecondTab,
		ThirdTab,
		FourthTab,
		FifthTab
	},
	props: {
		permissions: Object,
		trailerId: Number,
	},
	computed: {
		...mapGetters([ 'trailersItem' ]),
		getIndicatorColor() {
			const id = this.status_id?.id ?? this.status_id;
			return STATUS_TRUCK_COLOR[id];
		},
		isChangeCompanyButton() {
			return this.typeForm === 'edit' && this.getPermissionAction;
		},
		getPermissionAction() {
			if ((this.permissions[8] && !this.trailerId) || this.permissions[9]) return false;
			return this.permissions[10];
		},
		getTabList() {
			const {
				size,
				trailer_number,
				date_from,
				customer_id,
				trailer_type_id
			} = this.$v;

			const values = [
				{
					text: 'General info',
					error: size.$error || trailer_number.$error || date_from.$error || customer_id.$error || trailer_type_id.$error
				}
			];

			if (!this.trailerId) {
				return values;
			}

			return [ ...values,
				{
					text: 'Repairs',
					error: false
				},
				{
					text: 'Equipment',
					error: false
				},
				{
					text: 'Trailer value',
					error: false
				},
				{
					text: 'Notes',
					error: false
				} ];
		}
	},
	data: () => ({
		hours: null,
		originValue: null,
		status_id: null,
		tab: null,
		size: '',
		trailer_number: '',
		customer_id: null,
		trailer_id: null,
		date_from: getDefaultDate(),
		company_owner: false,
		active: false,
		left_company: false,
		sold: false,
		vin_code: null,
		plate: null,
		model: null,
		gps_name: null,
		gps: false,
		eld_name: null,
		eld: false,
		driver_id: null,
		driver_second_id: null,
		trailer_type: null,
		team: false,
		id: null,
		isChangeCompany: false,
		truck_equipment: [],
		statusList: [],
		customers: [],
		drivers: [],
		equipments: [],
		trailer: [],
		services: {},
		change_company: [],
		trailerType: [],
		trailer_type_id: null,
	}),
	validations() {
		return {
			size: { required },
			trailer_number: { required },
			date_from: { required },
			customer_id: { required },
			trailer_type_id: { required },
			gps_name: this.gps ? { required } : {},
			eld_name: this.eld ? { required } : {}
		};
	},
	methods: {
		...mapActions([ 'onTrailersCreate', 'onTrailersEdit', 'setAlert', 'onTrailersSave', 'onTrailersHistory' ]),

		async onTab(value) {
			this.tab = value;
		},
		onChangeCompany(value) {
			this.isChangeCompany = value;
		},
		onEditServices(obj) {
			const index = this.change_company.findIndex(item => item.id === obj.id);
			this.change_company.splice(index, 1, obj);
		},
		onUpdateValueTab({ value, key }) {
			this[key] = value?.id ?? value;
		},
		onClose(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onClearAutocomplete({ value }, key) {
			this[key] = value;
		},
		async onAutocomplete({ value }, key) {
			if (!value) return false;
			this[key] = value?.id ?? value;

			if (key === 'customer_id') {
				const id = value?.id;
				this.driver_id = null;

				if (id) {
					const data = await this.onTrailersCreate(id);
					if (data) {
						const { customers, driver, trailer } = data;
						this.customers = customers;
						this.drivers = driver;
						this.trailer = trailer;
					}
				}
			}

			if (key === 'trailer_id') {
				this.trailer_type = value['trailer_type'];
			}
		},
		onEquipmentsSelectList(values) {
			this.equipments = values;
		},
		onDate(date, key) {
			this[key] = date;
		},
		onCheckbox(value, key) {
			this[key] = value;
		},
		closeDialog() {
			this.$emit('updateClose');
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.loading = true;
				const {
					size,
					trailer_number,
					customer_id,
					trailer_id,
					date_from,
					company_owner,
					active,
					left_company,
					sold,
					vin_code,
					plate,
					gps_name,
					gps,
					eld_name,
					eld,
					model,
					driver_id,
					status_id,
					driver_second_id,
					trailer_type,
					team,
					change_company,
					truck_equipment,
					trailer_type_id,
					hours,
					originValue
				} = this.$data;

				const history = change_company ?? [].map(item => {
					const { id, truck_id, customer_id, from, to } = item;
					return { id, truck_id, customer_id, from, to };
				});

				const values = {
					size,
					trailer_number,
					customer_id,
					trailer_id,
					date_from,
					company_owner: Number(company_owner),
					active: Number(active),
					left_company: Number(left_company),
					sold: Number(sold),
					vin_code,
					plate,
					gps_name,
					gps: Number(gps),
					eld_name,
					eld: Number(eld),
					model,
					driver_id,
					status_id,
					driver_second_id,
					trailer_type,
					team: Number(team),
					truck_equipment,
					trailer_type_id,
					hours,
					originValue
				};

				const data = await this.onTrailersSave({ values, trailer_id });
				if (history.length) await this.onTrailersHistory(history);

				if (!data.error) {
					this.setAlert({ type: "success", message: "Saving Successfully" });
					this.onClose(1);
				} else {
					const { size, trailer_number, vin_code, customer_id, trailer_type_id } = data.error;
					const vinError = size || trailer_number || vin_code || customer_id || trailer_type_id;
					this.setAlert({ type: "error", message: vinError ? vinError[0] : "Saving error" });
				}

				this.loading = false;
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}
		}
	},
	async mounted() {
		if (!this.trailerId) {
			await this.onTrailersCreate(null);
		} else {
			await this.onTrailersEdit(this.trailerId);
		}

		const {
			customers,
			drivers,
			equipments,
			status,
			trailer,
			trailerType,

			change_company,
			truck_equipment,
		} = this.trailersItem;

		this.customers = customers;
		this.drivers = drivers;
		this.trailer = trailer;
		this.trailerType = trailerType;
		this.truck_equipment = truck_equipment;
		this.change_company = change_company;
		this.equipments = equipments;
		this.statusList = status;
		this.hours = trailer?.hours;
		this.originValue = trailer?.originValue;
		this.services = {
			next_date_inspection: trailer?.next_annual_inspection_date,
			next_date_alignment: trailer?.next_date_alignment,
			next_mileage_pm: trailer?.next_mileage_pm
		};

		if (trailer) {
			for (const trailerKey in trailer) {
				this[trailerKey] = trailer[trailerKey];
			}
		}
	}
};
</script>
<style lang="scss">
.checkboxWrapper {
	.v-label {
		font-size: 14px;
		line-height: 20px;
	}
}
</style>
<style scoped lang="scss">
//@import "trailersForm";
@import "@/assets/style/components/formDialog.scss";
</style>
